import { render, staticRenderFns } from "./knowledge.vue?vue&type=template&id=2a482635"
import script from "./knowledge.vue?vue&type=script&lang=js"
export * from "./knowledge.vue?vue&type=script&lang=js"
import style0 from "./knowledge.vue?vue&type=style&index=0&id=2a482635&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports